import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

/** Preserves return navigation via router state for drill-down links. */
export function DrillLink({
  to,
  from,
  children,
  className,
}: {
  to: string;
  from: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Link
      to={to}
      state={{ from }}
      className={className ?? 'font-mono text-xs font-semibold text-primary hover:underline'}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </Link>
  );
}
